import React, { useEffect, useRef, useState } from "react";
import PinesMultiSelect from "../../../components/multiselect/PinesMultiSelect";
import BtnGuardar from "../../../components/buttons/BtnGuardar";
import BtnCancelar from "../../../components/buttons/BtnCancelar";
import useSeleccionConCambios from "../../../utils/useSeleccionConCambios";

import { appFetchJson } from "../../../utils/http";
import apiRoutes from "../../../api/apiRoutes";

export default function InactivarPinesPlayero({
  estacion,
  onClose = () => {},
  onSaved = () => {},
}) {
  const [cargando, setCargando] = useState(true);
  const [guardando, setGuardando] = useState(false);

  const [idsSeleccionados, setIdsSeleccionados] = useState([]);

  // 🔹 datos del multiselect
  const [itemsPines, setItemsPines] = useState([]);
  const [loadingPines, setLoadingPines] = useState(false);
  const [errorPines, setErrorPines] = useState("");

  const ejecucionDevRef = useRef(false);

  const { inicializar, tieneCambios } =
    useSeleccionConCambios(idsSeleccionados);

  // =========================
  // CARGA COMPLETA DE PINES
  // =========================
  useEffect(() => {
    if (!estacion?.id) return;

    // evitar doble ejecución en dev
    if (process.env.NODE_ENV !== "production") {
      if (!ejecucionDevRef.current) {
        ejecucionDevRef.current = true;
        return;
      }
    }

    const loadAllPines = async () => {
      setCargando(true);
      setLoadingPines(true);
      setErrorPines("");

      let page = 0;
      const size = 200; // grande a propósito
      let hasMore = true;

      const acumulado = [];

      try {
        while (hasMore) {
          const data = await appFetchJson(
            apiRoutes.pines.inactivables({
              tipo: "PLAYERO",
              eessId: estacion.id,
              page,
              size,
            })
          );

          const mapped = (data.items || []).map((p) => ({
            id: p.id,
            label: `${p.numeroResponsable ?? ""} - ${p.numero}`,
          }));

          acumulado.push(...mapped);

          hasMore = data.hasMore === true;
          page += 1;
        }

        setItemsPines(acumulado);

        // 🔹 inicializamos selección con snapshot vacío
        inicializar([]);
      } catch (e) {
        console.error(e);
        setErrorPines("No se pudieron cargar los pines playeros");
        setItemsPines([]);
      } finally {
        setLoadingPines(false);
        setCargando(false);
      }
    };

    loadAllPines();
  }, [estacion?.id, inicializar]);

  const hayQueGuardar =
    tieneCambios && idsSeleccionados.length > 0 && !guardando;

  // =========================
  // GUARDAR (mock)
  // =========================
  const handleGuardar = async (e) => {
    e?.preventDefault?.();
    if (!hayQueGuardar) return;

    setGuardando(true);
    try {
      const payload = {
        id: estacion.id,        // no se usa hoy, pero es coherente con EessRequestDto
        pinIds: idsSeleccionados,
      };

      const resp = await appFetchJson(
        apiRoutes.eess.inactivarPines,
        {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        }
      );

      onSaved?.(resp);
      onClose?.();
    } catch (err) {
      console.error(err);
      alert("No se pudieron inactivar los pines seleccionados");
    } finally {
      setGuardando(false);
    }
  };

  const totalPines = itemsPines.length;
  return (
    
    <Modal title="Inactivar Pines Playeros">
      {cargando ? (
        <div className="py-8 text-center">Cargando…</div>
      ) : (
        <form className="space-y-5">
          {/* ESTACIÓN */}
          <div className="border rounded bg-gray-50">
            <div className="px-4 py-3">
              <div className="flex gap-2">
                <div className="w-40 font-medium text-gray-700">EE.SS.:</div>
                <div className="text-gray-800">
                  {estacion ? (
                    <>
                      <b>{estacion.codigoEstacion ?? estacion.id}</b>
                      {estacion.nombreEstacion
                        ? ` — ${estacion.nombreEstacion}`
                        : ""}
                    </>
                  ) : (
                    <span className="text-gray-500">Sin estación</span>
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* PINES */}

          <div className="border rounded bg-gray-50">
            <div className="px-4 py-3">
              <div className="flex gap-2">
                <div className="w-40 font-medium text-gray-700">Pin(es) Activo(s):</div>
                <div className="text-gray-800">
                  <span className="text-gray-500">{totalPines}</span>
                </div>
              </div>
            </div>
          </div>
          <div className="border rounded bg-gray-50">
            <div className="section-panel">
              <div className="form-row gap-2">
                <div className="form-label">
                  <span className="text-gray-600">
                    Pin(es) a Inactivar:
                  </span>{" "}
                </div>
                <div className="flex-1">
                  <PinesMultiSelect
                    items={itemsPines}
                    value={idsSeleccionados}
                    onChange={setIdsSeleccionados}
                    loading={loadingPines}
                    error={errorPines}
                  />
                </div>
              </div>
            </div>
          </div>

          {/* BOTONES */}
          <div className="modal-footer">
            <div className="btn-row">
              <BtnGuardar
                isValid={hayQueGuardar}
                saving={guardando}
                onClick={handleGuardar}
              />
              <BtnCancelar onClick={onClose} />
            </div>
          </div>
        </form>
      )}
    </Modal>
  );
}

/* ---------- Modal base ---------- */
function Modal({ title, children }) {
  return (
    <div className="modal-backdrop">
      <div className="modal-panel-md">
        <div className="modal-header">
          <h2 className="section-title">{title}</h2>
        </div>
        <div className="modal-body">{children}</div>
      </div>
    </div>
  );
}
